export default __webpack_public_path__ + "static/media/bb_guess_5.76bda8a8.png";